// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationSearchingOrdersPath = 'M100 2v60.5c0 5.704-4.548 10.346-10.216 10.496L89.5 73H38.287A22.419 22.419 0 0129 75c-2.827 0-5.531-.521-8.024-1.473l-.393.775 5.18 2.626-8.147 16.073a9.31 9.31 0 01-5.409 4.64c-2.205.72-4.599.593-6.786-.392l-.318-.153a9.31 9.31 0 01-4.095-12.513L9.155 68.51l5.184 2.627.56-1.103C9.777 65.91 6.5 59.588 6.5 52.5A22.4 22.4 0 0111 38.998V2h89zM18 32.868L17.999 9H44v23.163l11.5-5.75 11.5 5.75V9h25.999L93 62.5l-.005.192A3.5 3.5 0 0189.5 66H47.002A22.4 22.4 0 0051.5 52.5C51.5 40.074 41.426 30 29 30a22.399 22.399 0 00-11 2.868zM51 9h9v11.837l-4.5-2.25-4.5 2.249V9zM38 44v7H20v-7h18zm-6 18v-7H20v7h12zm-3-25c8.56 0 15.5 6.94 15.5 15.5C44.5 61.06 37.56 68 29 68c-8.56 0-15.5-6.94-15.5-15.5C13.5 43.94 20.44 37 29 37zM16.354 80.006l-4.12-2.089-4.982 9.83c-.553 1.091-.158 2.413.812 2.997l.13.072.171.083a2.31 2.31 0 003.007-1.063l4.982-9.83z';
var IllustrationSearchingOrders = baseIllustration('IllustrationSearchingOrders', {
  getPath: () => IllustrationSearchingOrdersPath
}, 'ColoredIllustrationSearchingOrders');

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationSearchingOrders;
//# sourceMappingURL=index.js.map